// extracted by css-extract-rspack-plugin
export default {"sectionLabel":"sectionLabel-QfpY7_"};